var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Centrifuge } from 'centrifuge';
import { useCallback, useEffect, useRef } from 'react';
import { useFetchCount } from './useFetchCount';
import { useCentrifugeOptions } from './useCentrifugeOptions';
export var useCentrifuge = function (username, _a) {
    if (_a === void 0) { _a = {}; }
    var api = _a.api, _b = _a.debug, debug = _b === void 0 ? false : _b, options = __rest(_a, ["api", "debug"]);
    var centrifuge = useRef();
    var subscription = useRef();
    var interval = useRef();
    var _c = useFetchCount({ api: api, username: username, options: options }), count = _c.count, error = _c.error, setCount = _c.setCount, onFetch = _c.onFetch;
    var url = useCentrifugeOptions(options).url;
    var disconnect = useCallback(function () {
        var _a;
        (_a = centrifuge.current) === null || _a === void 0 ? void 0 : _a.disconnect();
        clearInterval(interval.current);
    }, [centrifuge, interval]);
    var onChangeCount = useCallback(function (ctx) {
        setCount(ctx.data.count);
    }, [setCount]);
    // Subscribe on notifications WS channel
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (error) {
            var message = 'Не удалось получить количество уведомлений по адресу: ';
            console.error("".concat(message).concat(api).concat(username, "/"));
            return;
        }
        if (url) {
            if (!centrifuge.current) {
                centrifuge.current = new Centrifuge(url, {
                    debug: debug,
                });
            }
        }
        else {
            console.error('Не указан CENTRIFUGE_URL');
        }
        if (((_a = centrifuge.current) === null || _a === void 0 ? void 0 : _a.state) === 'disconnected') {
            (_b = centrifuge.current) === null || _b === void 0 ? void 0 : _b.connect();
        }
        (_c = subscription.current) === null || _c === void 0 ? void 0 : _c.off('publication', onChangeCount);
        (_d = subscription.current) === null || _d === void 0 ? void 0 : _d.unsubscribe();
        var subscriptions = (_e = centrifuge.current) === null || _e === void 0 ? void 0 : _e.subscriptions();
        var channelName = "notifications:".concat(username);
        if (subscriptions && !subscriptions[channelName]) {
            subscription.current = (_f = centrifuge.current) === null || _f === void 0 ? void 0 : _f.newSubscription(channelName);
        }
        else if (subscriptions && subscriptions[channelName]) {
            subscription.current = subscriptions[channelName];
        }
        (_g = subscription.current) === null || _g === void 0 ? void 0 : _g.subscribe();
        (_h = subscription.current) === null || _h === void 0 ? void 0 : _h.on('publication', onChangeCount);
        if (interval.current) {
            clearInterval(interval.current);
        }
        return function () { return disconnect(); };
    }, [url, api, error, debug, username, disconnect, onChangeCount]);
    // Initialize notifications via GET
    useEffect(function () {
        onFetch();
    }, [onFetch]);
    return { count: count };
};
//# sourceMappingURL=useCentrifuge.js.map